import { useEffect, useState } from "react";

/**
 * 「デバイスを追加」のダウンロードの情報をマウント時に取得する。info が undefined なら取得中、
 * null は設定が無く配れない (backend の 503)。error は取得の失敗で、retry で取り直す。
 */
export function useRunnerDownloadInfo<T>(load: () => Promise<T | null>, failure: string) {
	const [info, setInfo] = useState<T | null | undefined>(undefined);
	const [error, setError] = useState<string | null>(null);
	const [attempt, setAttempt] = useState(0);

	useEffect(() => {
		let cancelled = false;
		const run = async () => {
			try {
				const latest = await load();
				if (!cancelled) setInfo(latest);
			} catch (err) {
				if (!cancelled) setError(err instanceof Error ? err.message : failure);
				throw err;
			}
		};
		void run().catch((err: unknown) => {
			console.error(failure, err);
		});
		return () => {
			cancelled = true;
		};
	}, [load, failure, attempt]);

	const retry = () => {
		setError(null);
		setAttempt((current) => current + 1);
	};

	return { info, error, retry };
}
